import { render, staticRenderFns } from "./portraitMenu.vue?vue&type=template&id=2e1a48fb"
import script from "./portraitMenu.vue?vue&type=script&lang=js"
export * from "./portraitMenu.vue?vue&type=script&lang=js"
import style0 from "./portraitMenu.vue?vue&type=style&index=0&id=2e1a48fb&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports